'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _VstComponent2 = require('./VstComponent');

var _VstComponent3 = _interopRequireDefault(_VstComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VstTableBody = function (_VstComponent) {
  _inherits(VstTableBody, _VstComponent);

  function VstTableBody() {
    _classCallCheck(this, VstTableBody);

    var _this = _possibleConstructorReturn(this, (VstTableBody.__proto__ || Object.getPrototypeOf(VstTableBody)).call(this));

    _this._sort = _this._sort.bind(_this);
    _this._getString = _this._getString.bind(_this);
    return _this;
  }

  _createClass(VstTableBody, [{
    key: '_sort',
    value: function _sort(a, b) {
      var _props = this.props,
          sortIndex = _props.sortIndex,
          sortOrder = _props.sortOrder;

      if (sortIndex === null) {
        return;
      }

      // I don't love this
      // Checks the row's sorted cell for a sort prop and defaults to the cell's child
      var aProps = a.props.children[sortIndex].props;
      var aSortValue = typeof aProps.sort !== 'undefined' ? aProps.sort : this._getString(aProps.children).toLowerCase();

      var bProps = b.props.children[sortIndex].props;
      var bSortValue = typeof bProps.sort !== 'undefined' ? bProps.sort : this._getString(bProps.children).toLowerCase();
      /* eslint consistent-return: "off" */
      if (aSortValue > bSortValue) return sortOrder;
      if (aSortValue < bSortValue) return sortOrder * -1;
      return 0;
    }
  }, {
    key: '_getString',
    value: function _getString(children) {
      var _this2 = this;

      var result = '';
      if (children.props && children.props.children) {
        if (children.props.children.forEach) {
          children.props.children.forEach(function (child) {
            result += _this2._getString(child);
          });
        } else {
          result += children.props.children;
        }
        return result;
      } else if (children.forEach) {
        children.forEach(function (child) {
          result += _this2._getString(child);
        });
        return result;
      }

      return children;
    }
  }, {
    key: 'render',
    value: function render() {
      var children = _react2.default.Children.toArray(this.props.children);
      children = children.sort(this._sort);

      return _react2.default.createElement(
        'tbody',
        null,
        children
      );
    }
  }]);

  return VstTableBody;
}(_VstComponent3.default);

exports.default = VstTableBody;


/** WEBPACK FOOTER **
 ** ./~/vstui/lib/components/VstTableBody.js
 **/